export const siteInfo = {
  name: "爱情岛论坛",
  tagline: "温暖有爱的社区交流平台",
  description: "爱情岛论坛网站是广受用户喜爱的交流社区平台，提供最新内容入口、注册登录指南及使用攻略。汇聚情感交流、生活分享、技术讨论等多元板块，打造温馨优质的在线社区体验。",
  keywords: "爱情岛论坛,爱情岛论坛网站入口,爱情岛论坛网站官网,爱情岛论坛网站注册,爱情岛论坛网站最新地址,爱情岛社区论坛,爱情岛论坛使用攻略",
  url: "https://www.aiqingdao.net",
  logo: "爱情岛",
};

export const navLinks = [
  { label: "首页", href: "/" },
  { label: "分类浏览", href: "/category/qinggan-jiaoliu" },
  { label: "关于我们", href: "/about" },
];

export const categories = [
  {
    slug: "qinggan-jiaoliu",
    name: "情感交流",
    icon: "ri-heart-line",
    desc: "分享你的情感故事，倾听他人的心声",
    color: "bg-rose-100 text-rose-700",
    articleCount: 1286,
  },
  {
    slug: "shenghuo-fenxiang",
    name: "生活分享",
    icon: "ri-sun-line",
    desc: "记录日常点滴，发现生活之美",
    color: "bg-amber-100 text-amber-700",
    articleCount: 953,
  },
  {
    slug: "jishu-taolun",
    name: "技术讨论",
    icon: "ri-code-line",
    desc: "探讨前沿技术，共享开发经验",
    color: "bg-emerald-100 text-emerald-700",
    articleCount: 742,
  },
  {
    slug: "yule-bagua",
    name: "娱乐八卦",
    icon: "ri-movie-line",
    desc: "畅聊影视综艺，追踪热点趣闻",
    color: "bg-violet-100 text-violet-700",
    articleCount: 2105,
  },
  {
    slug: "meishi-lvyou",
    name: "美食旅游",
    icon: "ri-cup-line",
    desc: "探索世界美味，规划旅行路线",
    color: "bg-orange-100 text-orange-700",
    articleCount: 867,
  },
  {
    slug: "jiankang-yangsheng",
    name: "健康养生",
    icon: "ri-mental-health-line",
    desc: "关注身心健康，学习养生之道",
    color: "bg-teal-100 text-teal-700",
    articleCount: 634,
  },
];

export const heroFeatures = [
  { icon: "ri-shield-check-line", text: "安全可靠" },
  { icon: "ri-group-line", text: "百万用户" },
  { icon: "ri-message-3-line", text: "实时交流" },
  { icon: "ri-smartphone-line", text: "多端同步" },
];

export const features = [
  {
    icon: "ri-discuss-line",
    title: "多元社区板块",
    desc: "涵盖情感、生活、技术、娱乐等多个领域，无论你的兴趣是什么，都能在这里找到志同道合的伙伴。",
  },
  {
    icon: "ri-shield-star-line",
    title: "安全隐私保护",
    desc: "采用先进的加密技术与严格的社区管理规范，全方位守护你的账户安全与个人隐私。",
  },
  {
    icon: "ri-rocket-2-line",
    title: "流畅体验设计",
    desc: "精心优化的界面交互与加载速度，让你畅享丝滑的浏览体验，随时随地轻松访问。",
  },
  {
    icon: "ri-award-line",
    title: "优质内容生态",
    desc: "严格的审核机制与活跃的用户互动，确保社区内容的真实性与高质量，拒绝低质信息污染。",
  },
  {
    icon: "ri-gift-2-line",
    title: "丰富会员权益",
    desc: "注册即享基础权益，升级会员解锁更多专属功能与福利，让你的社区之旅更加精彩。",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "贴心客服支持",
    desc: "7x24小时在线客服团队，快速响应你的每一个问题，用心守护你的每一次访问体验。",
  },
];

export const stats = [
  { value: "380万+", label: "注册用户" },
  { value: "12万+", label: "日均发帖" },
  { value: "500万+", label: "累计话题" },
  { value: "98.6%", label: "用户好评" },
];

export const hotArticles = [
  {
    id: "article-1",
    title: "新人必读：爱情岛论坛完整使用攻略与注意事项",
    excerpt: "本文为刚加入爱情岛论坛的新用户梳理了从注册到熟练使用的全部流程，包括账号设置、板块选择、发帖技巧以及社区规范等重要内容。",
    category: "使用攻略",
    categorySlug: "shiyong-gonglve",
    date: "2026-08-01",
    readCount: 52890,
    commentCount: 1236,
    imageSeq: "hot-article-01",
  },
  {
    id: "article-2",
    title: "如何在爱情岛论坛找到志同道合的朋友？",
    excerpt: "在偌大的社区中找到真正懂你的人并不容易。本文从兴趣匹配、板块选择、互动技巧等角度，分享在爱情岛论坛建立深度社交关系的方法。",
    category: "社区指南",
    categorySlug: "shequ-zhinan",
    date: "2026-07-28",
    readCount: 41230,
    commentCount: 987,
    imageSeq: "hot-article-02",
  },
  {
    id: "article-3",
    title: "2026年爱情岛论坛最新功能更新全览",
    excerpt: "爱情岛论坛近期上线了多项重磅功能更新，包括全新UI界面、智能推荐算法、语音发帖等。本文为你逐一解读这些新功能的亮点与使用方法。",
    category: "平台动态",
    categorySlug: "pingtai-dongtai",
    date: "2026-07-25",
    readCount: 38750,
    commentCount: 852,
    imageSeq: "hot-article-03",
  },
  {
    id: "article-4",
    title: "爱情岛论坛账号安全防护指南",
    excerpt: "网络安全不容忽视！本文详细介绍了爱情岛论坛的账号保护机制，并提供了密码设置、二次验证、防钓鱼等实用安全建议。",
    category: "使用攻略",
    categorySlug: "shiyong-gonglve",
    date: "2026-07-20",
    readCount: 29600,
    commentCount: 645,
    imageSeq: "hot-article-04",
  },
  {
    id: "article-5",
    title: "情感交流板块精华帖合集：那些触动心灵的分享",
    excerpt: "我们精心整理了情感交流板块中获赞最高的50篇精华帖，涵盖恋爱关系、家庭相处、自我成长等话题，每一篇都值得细细品读。",
    category: "情感交流",
    categorySlug: "qinggan-jiaoliu",
    date: "2026-07-15",
    readCount: 51200,
    commentCount: 1567,
    imageSeq: "hot-article-05",
  },
  {
    id: "article-6",
    title: "从零开始搭建你的爱情岛个人主页",
    excerpt: "想让你的个人主页更加个性化吗？本文手把手教你如何美化主页布局、设置头像封面、编辑个人简介，打造独一无二的社区形象。",
    category: "使用攻略",
    categorySlug: "shiyong-gonglve",
    date: "2026-07-10",
    readCount: 22450,
    commentCount: 478,
    imageSeq: "hot-article-06",
  },
];

export const faqs = [
  {
    q: "爱情岛论坛网站如何注册账号？",
    a: "打开爱情岛论坛官方网站，点击右上角的「注册」按钮，填写邮箱地址或手机号码，设置登录密码，完成验证后即可成功注册。注册过程简单快捷，约1-2分钟即可完成。建议使用真实邮箱注册，以便后续账号找回和接收重要通知。",
  },
  {
    q: "爱情岛论坛网站的最新入口地址是什么？",
    a: "爱情岛论坛网站的官方域名为 www.aiqingdao.net，建议将此地址收藏至浏览器书签。如遇访问异常，可通过官方社交媒体账号（微信公众号、微博）获取最新可用地址。请注意甄别仿冒网站，务必通过官方渠道访问。",
  },
  {
    q: "忘记密码了怎么办？",
    a: "在登录页面点击「忘记密码」，输入注册时使用的邮箱或手机号，系统会发送密码重置链接或验证码。按照提示重新设置密码即可。如遇到任何问题，可联系在线客服获得人工协助。",
  },
  {
    q: "爱情岛论坛有哪些主要功能板块？",
    a: "爱情岛论坛目前设有情感交流、生活分享、技术讨论、娱乐八卦、美食旅游、健康养生六大核心板块。每个板块下还有细分话题标签，方便用户精准定位感兴趣的内容。此外还有热门排行、精华推荐、个人空间等辅助功能。",
  },
  {
    q: "在论坛发帖需要遵守哪些规则？",
    a: "爱情岛论坛倡导文明友善的交流氛围。发帖时请遵守：不发布违法违规内容、不进行人身攻击、不传播虚假信息、不恶意灌水刷屏。具体规则可查阅《爱情岛社区管理规范》。违规内容将根据情节严重程度予以删除、警告或封禁处理。",
  },
  {
    q: "爱情岛论坛支持手机访问吗？",
    a: "完全支持！爱情岛论坛采用响应式设计，自动适配手机、平板和电脑等各类设备。你也可以通过官方App（iOS/Android）获得更流畅的移动端体验。App在各大应用商店搜索「爱情岛」即可下载。",
  },
  {
    q: "如何举报不当内容或用户？",
    a: "每条帖子右下角都有「举报」按钮，点击后选择举报原因并提交即可。我们的审核团队会在24小时内处理举报。对于紧急情况，也可以直接联系在线客服进行人工反馈。",
  },
  {
    q: "爱情岛论坛会员有哪些权益？",
    a: "普通会员可免费浏览、发帖、评论和私信。VIP会员额外享有去广告、专属标识、更大附件上传空间、帖子置顶特权、优先客服响应等权益。会员等级分为月卡、季卡和年卡三种，可按需选购。",
  },
];

export const footerLinks = {
  navigation: [
    { label: "首页", href: "/" },
    { label: "分类浏览", href: "/category/qinggan-jiaoliu" },
    { label: "热门排行", href: "/category/qinggan-jiaoliu" },
    { label: "精华推荐", href: "/category/qinggan-jiaoliu" },
    { label: "关于我们", href: "/about" },
  ],
  categories: [
    { label: "情感交流", href: "/category/qinggan-jiaoliu" },
    { label: "生活分享", href: "/category/shenghuo-fenxiang" },
    { label: "技术讨论", href: "/category/jishu-taolun" },
    { label: "娱乐八卦", href: "/category/yule-bagua" },
    { label: "美食旅游", href: "/category/meishi-lvyou" },
    { label: "健康养生", href: "/category/jiankang-yangsheng" },
  ],
  help: [
    { label: "新手指南", href: "/article/article-1" },
    { label: "常见问题", href: "/#faq" },
    { label: "联系我们", href: "/about#contact" },
    { label: "用户协议", href: "/about" },
    { label: "隐私政策", href: "/about" },
  ],
};